import React from 'react';
import { translate } from '@utils/i18n';
import { Tag } from '@ui/atoms/Tag';
import { Tooltip } from '@ui/atoms/Tooltip';
import { NAMESPACE } from '../constants';
const STATUS_VARIANT = {
    due: 'red',
    upcoming: 'blue'
};
export function StatusCell({ item }) {
    var _a, _b, _c;
    if (!item.status)
        return null;
    const tooltip = translate(`status_reason.${item.status}`, {
        namespace: NAMESPACE,
        responseType: item.nfpaType || '—',
        interval: (_a = item.interval) !== null && _a !== void 0 ? _a : '—',
        edition: (_b = item.nfpaEdition) !== null && _b !== void 0 ? _b : '—',
        nextService: (_c = item.nextServiceDate) !== null && _c !== void 0 ? _c : '—'
    });
    return (React.createElement(Tooltip, { content: tooltip, multiline: true, position: "left" },
        React.createElement(Tag, { label: translate(`status.${item.status}`, { namespace: NAMESPACE }), variant: STATUS_VARIANT[item.status], readOnly: true })));
}
